import CommonButton from "@amplio-common/components/Button";

export default CommonButton;

